// File: src/components/StockIssues.js

import React, { useEffect, useState } from "react";
import { Row, Col, Table, Button } from "react-bootstrap";
import ApiManager from "../utils/ApiManager";
import DataManager from "../utils/DataManager";
import RowCountLabel from "./RowCountLabel";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Link } from "react-router-dom";

import "./Movements.css"; // Riutilizza lo stesso stile per coerenza
import "./StockIssues.css"; // <-- aggiungiamo un CSS dedicato

const StockIssues = () => {
  const [issues, setIssues] = useState([]);

  const fetchData = () => {
    ApiManager.Top.stockIssues(
      (data) => {
        setIssues(data.issues || []);
      },
      (error) => {
        console.error("Error fetching stock issues:", error);
      },
      () => {}
    );
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="movements">
      <Row className="mb-3">
        <Col></Col>
        <Col className="text-end">
          <Button variant="secondary" onClick={fetchData} title="Aggiorna dati">
            <RefreshIcon />
          </Button>
        </Col>
      </Row>

      <Row className="mb-3">
        <Col>
          <RowCountLabel count={issues?.length} label="Errori trovati" />

          {/* Contenitore scrollabile */}
          <div className="table-container">
            <Table striped bordered hover size="sm">
              <thead className="sticky-header">
                <tr>
                  <th>Articolo</th>
                  <th className="text-end">Celle</th>
                  <th className="text-end">Traslo Celle</th>
                  <th className="text-end">Traslo Reale</th>
                  <th className="text-end">Nts Qta</th>
                  <th className="text-end">Nts Esist</th>
                  <th className="text-end">Nts Impeg</th>
                </tr>
              </thead>
              <tbody>
                {issues?.map((row, index) => (
                  <tr key={`issue-${row.ProductId}-${index}`}>
                    <td>
                      <Link
                        to={`/articoli?productId=${row.ProductId}`}
                        className="card-link"
                      >
                        {row.ProductId}
                      </Link>
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.CellsQty, 0)}
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.TrasloCellsQty, 0)}
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.TrasloRealQty, 0)}
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.NtsQty, 0)}
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.NtsEsist, 0)}
                    </td>
                    <td className="text-end">
                      {DataManager.Decimal.format(row.NtsImpeg, 0)}
                    </td>
                  </tr>
                ))}
                {issues?.length === 0 && (
                  <tr>
                    <td colSpan="8" className="text-center text-muted">
                      Nessun dato disponibile
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default StockIssues;
